import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Modal from 'shared/components/Modal';
import PaymentModal from 'shared/components/PaymentModal';
import { KINDS } from 'shared/constants/payment';
import withMonoPayment from 'shared/hocs/withMonoPayment';

import s from './BalanceRefill.css';

class BalanceRefill extends React.Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    openMonoOrderWindow: PropTypes.func.isRequired,
    // onModalOpen: PropTypes.func,
    onModalClose: PropTypes.func,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    onModalOpen: () => {},
    onModalClose: () => {},
  };

  state = {
    refillAmount: 99,
    showModal: false,
  };

  handleChange = e => {
    const { value } = e.target;

    if (value === '') {
      this.setState({ refillAmount: null });
    } else {
      const intValue = parseInt(value, 10);

      if (intValue) {
        this.setState({ refillAmount: intValue });
      }
    }
  };

  handleShow = () => {
    // this.props.onModalOpen();
    // this.setState({ showModal: true });
    const { token, openMonoOrderWindow } = this.props;
    const { refillAmount } = this.state;

    openMonoOrderWindow(
      token,
      {
        kind: KINDS.BALANCE_REFILL,
        details: {
          refill_amount: refillAmount,
        },
      },
      `${window.location.pathname}${window.location.search}`, // return to where we are
      'mono',
    );
  };

  handleHide = () => {
    this.props.onModalClose();
    this.setState({ showModal: false });
  };

  // handlePaymentMethodChosen = paymentMethodInfo => {
  //   const { token, openMonoOrderWindow } = this.props;
  //   const { refillAmount } = this.state;

  //   openMonoOrderWindow(
  //     token,
  //     {
  //       kind: KINDS.BALANCE_REFILL,
  //       details: {
  //         refill_amount: refillAmount,
  //       },
  //     },
  //     `${window.location.pathname}${window.location.search}`, // return to where we are
  //     paymentMethodInfo.slug,
  //   );
  // };

  renderModal = () => (
    <Modal>
      <PaymentModal
        title={this.props.intl.formatMessage({ id: 'Пополнение баланса' })}
        description={this.props.intl.formatMessage({
          id: 'Пополнение внутреннего баланса в аккаунте avtobazar.ua',
        })}
        closeHandler={this.handleHide}
        amount={this.state.refillAmount}
        // agreeHandler={this.handlePaymentMethodChosen}
        balanceRefillMode
      />
    </Modal>
  );

  render() {
    const { refillAmount, showModal } = this.state;

    return (
      <div>
        <div className={s.inputContainer}>
          <input
            type="text"
            className={cx(s.input)}
            value={refillAmount || ''}
            onChange={this.handleChange}
          />
          <span className={s.hrn}>грн</span>
          <button onClick={this.handleShow} className={s.inlineButton} disabled={!refillAmount}>
            <FormattedMessage id="Пополнить" />
          </button>
        </div>

        {showModal && this.renderModal()}
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  token: user.token,
});

export default withStyles(s)(connect(mapStateToProps)(withMonoPayment(injectIntl(BalanceRefill))));



// WEBPACK FOOTER //
// ./src/desktop/components/BalanceRefill/BalanceRefill.js